/* VYREN Theme JS */
(function(){
  'use strict';

  // Progress bar
  var bar = document.getElementById('vyren-bar');
  var nav = document.getElementById('vnav');
  var dot = document.getElementById('vyren-dot');

  window.addEventListener('scroll', function(){
    var pct = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
    if(bar) bar.style.width = pct + '%';
    if(nav) nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });

  // Cursor
  document.addEventListener('mousemove', function(e){
    if(dot){ dot.style.left = e.clientX + 'px'; dot.style.top = e.clientY + 'px'; }
  }, { passive: true });
  document.querySelectorAll('a,button,input,select,textarea').forEach(function(el){
    el.addEventListener('mouseenter', function(){ if(dot){ dot.style.width='14px'; dot.style.height='14px'; } });
    el.addEventListener('mouseleave', function(){ if(dot){ dot.style.width='6px'; dot.style.height='6px'; } });
  });

  // Reveal on scroll
  var revels = document.querySelectorAll('.rv');
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  revels.forEach(function(el){ io.observe(el); });

  // Drop card CTAs
  document.querySelectorAll('.vdc-cta:not([disabled])').forEach(function(btn){
    btn.addEventListener('click', function(){
      var s = this.dataset.success || 'Done ✓';
      this.textContent = s;
      this.style.color = '#CDFF00';
      this.style.borderColor = 'rgba(205,255,0,0.4)';
      this.disabled = true;
    });
  });

})();
